module.exports = __webpack_public_path__ + "assets/img/b7e0-ms.svg";